import { create } from 'zustand'

interface DismissedAlertState {
    dismissedAlertIds: Set<number>
    dismissAlert: (id: number) => void
    dismissAlerts: (ids: number[]) => void
    isDismissed: (id: number) => boolean
    clearDismissed: () => void
}

export const useDismissedAlertStore = create<DismissedAlertState>((set, get) => ({
    dismissedAlertIds: new Set(),
    dismissAlert: (id) => {
        set((state) => ({
            dismissedAlertIds: new Set(state.dismissedAlertIds).add(id),
        }))
    },
    dismissAlerts: (ids) => {
        set((state) => ({
            dismissedAlertIds: new Set([...state.dismissedAlertIds, ...ids]),
        }))
    },
    isDismissed: (id) => {
        return get().dismissedAlertIds.has(id)
    },
    clearDismissed: () => {
        set({ dismissedAlertIds: new Set() })
    },
}))
